import React, { useEffect, useState, useRef } from "react";
import { NavLink, useNavigate, useParams } from "react-router-dom";
import { API_URL } from "../shared/constant";
import axios from "axios";
import { toast } from "react-toastify";
import LoaderComponent from "../../admin/shared/loader";

const Add = () => {
  const navigate = useNavigate();
  let { id } = useParams();
  const [isLoading, setLoading] = useState(false);

  const [formData, setFormData] = useState({
    id: null,
    title: "",
    file: "",
    image: null,
    image_url: "",
    video: null,
    video_url: "",
  });

  const resetForm = () => {
    setFormData({
      id: null,
      title: "",
      file: "",
      iamge: "",
      video: "",
    });
  };

  const savePosts = () => {
    if (isValidForm()) {
      setLoading(true);
      const prodFormData = new FormData();
      prodFormData.append("title", formData.title);

      if (formData.image) {
        prodFormData.append("image", formData.image);
      }

      if (formData.video) {
        prodFormData.append("video", formData.video);
      }

      if (id) {
        prodFormData.append("id", id);
      }

      const pUrl = id
        ? API_URL.ADMIN_INFRASTRUCTURE_UPDATE
        : API_URL.ADMIN_INFRASTRUCTURE_SAVE;

      axios
        .post(pUrl, prodFormData)
        .then((res) => {
          if (res.data.status === 1) {
            toast.success(id ? "Updated" : "Saved", {
              autoClose: 3000,
              position: "top-center",
            });
            navigate("/admin/infrastructure", { replace: true });
          }
        })
        .catch((error) => {
          console.error(error);
          toast.error("Something went wrong!");
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };

  const onEdit = () => {
    axios.post(API_URL.ADMIN_INFRASTRUCTURE_GET, { id: id }).then((res) => {
      if (res.data.status === 1) {
        setFormData({
          id: res.data.data.id,
          title: res.data.data.title ? res.data.data.title : "",
          file: res.data.data.file ? res.data.data.file : "",
          image_url: res.data.data.image ? res.data.data.image : "",
          video_url: res.data.data.video ? res.data.data.video : "",
        });
      }
    });
  };
  const isValidForm = () => {
    if (!formData.title) return false;
    if (!id && !(formData.image || formData.video)) return false;
    return true;
  };

  useEffect(() => {
    id && onEdit();
  }, [id]);

  const styles = {
    menu: (baseStyles, state) => ({
      ...baseStyles,
      marginTop: 2,
      zIndex: 999,
    }),
  };

  return (
    <>
      <div className="card">
        <div className="card-body">
          <form onSubmit={(event) => event.preventDefault()}>
            <div className="row">
              <div className="col-md-4">
                <div className="form-group">
                  <label>Name</label>
                  <input
                    type="text"
                    name="title"
                    maxLength={30}
                    value={formData.title}
                    className="form-control"
                    id="title"
                    onChange={(event) => {
                      setFormData({ ...formData, title: event.target.value });
                    }}
                  />
                </div>
              </div>
              <div className="col-md-4">
                <div className="row">
                  <div className="col-md-12">
                    <div className="form-group">
                      <label>Image</label>
                      <input
                        accept="image/*"
                        type="file"
                        name="image"
                        className="form-control"
                        onChange={(e) => {
                          const file = e.target.files[0];
                          setFormData({
                            ...formData,
                            image: file,
                            video: null,
                          });
                        }}
                      />
                    </div>
                  </div>
                  {formData.image_url && (
                    <div className="col-md-12">
                      <label>Image Preview</label>
                      <div>
                        <a
                          href={formData.image_url}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <img
                            src={formData.image_url}
                            height={100}
                            width={100}
                            alt="post_image"
                          />
                        </a>
                      </div>
                    </div>
                  )}
                </div>
              </div>
              <div className="col-md-4">
                <div className="row">
                  <div className="col-md-12">
                    <div className="form-group">
                      <label>Video</label>
                      <input
                        accept="video/*"
                        type="file"
                        name="video"
                        className="form-control"
                        onChange={(e) => {
                          const file = e.target.files[0];
                          setFormData({
                            ...formData,
                            video: file,
                            image: null,
                          });
                        }}
                      />
                    </div>
                  </div>
                  {id && formData.video_url && (
                    <div className="col-md-12 mt-2">
                      <label>Video Preview</label>
                      <div>
                        <video width="150" height="150" controls>
                          <source src={formData.video_url} type="video/mp4" />
                          Your browser does not support the video tag.
                        </video>
                      </div>
                    </div>
                  )}
                </div>
              </div>

              <div className="col-md-12">
                <div className="text-end d-flex justify-content-end align-items-center gap-2">
                  {isLoading && (
                    <LoaderComponent type="watch" height={35} width={35} />
                  )}
                  <button
                    type="submit"
                    onClick={savePosts}
                    className="btn btn-primary"
                    disabled={isLoading}
                  >
                    {id ? "Update" : "Create"}
                  </button>
                  <NavLink
                    to="/admin/infrastructure"
                    className="btn btn-secondary"
                  >
                    Cancel
                  </NavLink>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default Add;
